import axios from "axios";

const apiClient = axios.create({
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// The first request after a quiet spell can fail: the Functions app and its database connections start
// cold, and the Static Web App gives up on the API after 45 seconds while the API carries on warming up.
// Retry a failed GET once (no response, or a 5xx) so the page loads without the user pressing Refresh.
// GETs only: they're read-only, whereas a POST (e.g. the Magrathea route check) shouldn't be repeated.
apiClient.interceptors.response.use(undefined, async (error) => {
  const config = error.config;
  const status = error.response?.status;
  const retryable = !error.response || status >= 500;
  if (!config || config.method !== "get" || config._retried || !retryable) {
    return Promise.reject(error);
  }
  config._retried = true;
  await new Promise((resolve) => setTimeout(resolve, 1000));
  return apiClient(config);
});

export default apiClient;
